import React from "react";

const TickIcon = React.memo(({ styles = {}, variations = {}, fill = "#0B6E1B" }) => {
	return (
		<svg
			width="13"
			height="10"
			viewBox="0 0 13 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			style={{ ...styles }}
			{...variations}
		>
			<path
				d="M11.3294 0.52832L3.80078 8.05697L0.938802 5.19499L-0.00390625 6.1377L3.80078 9.94238L12.2721 1.47103L11.3294 0.52832Z"
				fill={fill}
			/>
		</svg>
	);
});

export default TickIcon;
